<template>
	<div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
		<div class="modal-dialog modal-lg modal-fullscreen-sm-down" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title"><i class="far fa-file-invoice me-2"></i>Associa a fattura - {{ voce.TITOLO_VOCE }}</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<div v-if="caricato && !costo" class="alert alert-warning py-2 fs-sm">
						<i class="ph-info me-1"></i>La voce non genera un costo: servono un fornitore e un importo d'acquisto, con voce e attività attive e non escluse dal totale acquisto.
					</div>

					<template v-if="costo">
						<div class="d-flex flex-wrap gap-2 mb-3">
							<span class="badge bg-light text-dark p-2">Fornitore: <strong>{{ costo.INTESTATARIO }}</strong></span>
							<span class="badge bg-light text-dark p-2">Costo con IVA: <strong>&euro; {{ filters.formattaImporto(costo.IMPORTO) }}</strong></span>
							<span class="badge bg-light text-dark p-2">Fatturato: <strong>&euro; {{ filters.formattaImporto(costo.ASSOCIATO) }}</strong></span>
							<span class="badge p-2" :class="costo.RESIDUO > 0 ? 'bg-warning text-dark' : 'bg-success'">Da associare: &euro; {{ filters.formattaImporto(costo.RESIDUO) }}</span>
						</div>

						<h6 class="fw-semibold">Fatture associate</h6>
						<table class="table table-sm table-hover mb-3">
							<thead>
								<tr>
									<th>Fattura</th>
									<th style="width:18%;">Data</th>
									<th style="width:18%;" class="text-end">Totale fattura</th>
									<th style="width:18%;" class="text-end">Su questa voce</th>
									<th style="width:8%;"></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="a in associazioni" :key="a.ID_ASSOCIAZIONE">
									<td><a href="#" @click.prevent="apriFattura(a)">n. {{ a.NUMERO }}</a></td>
									<td class="fs-sm">{{ a.DATA_FATTURA_IT }}</td>
									<td class="text-end fs-sm">&euro; {{ filters.formattaImporto(a.IMPORTO_TOTALE) }}</td>
									<td class="text-end fs-sm fw-semibold">&euro; {{ filters.formattaImporto(a.IMPORTO) }}</td>
									<td class="text-center"><a href="#" v-if="$root.hasFunzionalita('COSTI_DELETE')" class="text-danger" title="Togli l'associazione" @click.prevent="dissocia(a)"><i class="ph-trash"></i></a></td>
								</tr>
								<tr v-if="associazioni.length == 0"><td colspan="5" class="text-muted fs-sm">Nessuna fattura associata</td></tr>
							</tbody>
						</table>

						<template v-if="costo.RESIDUO > 0 && canCreate">
							<div class="d-flex justify-content-between align-items-center mb-2">
								<h6 class="fw-semibold mb-0">Fatture del fornitore ancora da associare</h6>
								<button type="button" v-if="canFatturare && !nuova" class="btn btn-outline-success btn-sm" @click="apriNuova()"><i class="ph-plus me-1"></i>Nuova fattura per il residuo</button>
							</div>

							<div v-if="nuova" class="border rounded p-2 mb-3 bg-light">
								<div class="row g-2">
									<div class="col-md-3">
										<label class="form-label fs-sm mb-0">Numero</label>
										<input type="text" class="form-control form-control-sm" v-model="nuova.NUMERO" autocomplete="off">
									</div>
									<div class="col-md-3">
										<label class="form-label fs-sm mb-0">Data</label>
										<Datepicker v-model="nuova.DATA_FATTURA" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :enable-time-picker="false" :clearable="false" />
									</div>
									<div class="col-md-6">
										<label class="form-label fs-sm mb-0">Descrizione</label>
										<input type="text" class="form-control form-control-sm" v-model="nuova.DESCRIZIONE" autocomplete="off">
									</div>
									<div class="col-md-4">
										<label class="form-label fs-sm mb-0">Codice IVA</label>
										<select class="form-select form-select-sm" v-model="nuova.FK_ID_IVA">
											<option :value="0">— Nessuna —</option>
											<option v-for="c in filters.getCodiciIvaAttivi()" :key="c.ID_OPZIONE_TIPOLOGICA" :value="c.ID_OPZIONE_TIPOLOGICA">{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}</option>
										</select>
									</div>
									<div class="col-md-2">
										<label class="form-label fs-sm mb-0">Netto</label>
										<input type="text" class="form-control form-control-sm text-end" :value="filters.formattaImporto(nettoNuova)" disabled>
									</div>
									<div class="col-md-2">
										<label class="form-label fs-sm mb-0">IVA</label>
										<input type="text" class="form-control form-control-sm text-end" :value="filters.formattaImporto(costo.RESIDUO - nettoNuova)" disabled>
									</div>
									<div class="col-md-4 d-flex align-items-end gap-1">
										<button type="button" class="btn btn-success btn-sm" @click="creaFattura()">Salva</button>
										<button type="button" class="btn btn-light btn-sm" @click="nuova = null">Annulla</button>
									</div>
								</div>
							</div>

							<table class="table table-sm table-hover mb-0">
								<thead>
									<tr>
										<th>Fattura</th>
										<th style="width:15%;">Data</th>
										<th style="width:15%;" class="text-end">Totale</th>
										<th style="width:20%;" class="text-end">Libero</th>
										<th style="width:20%;" class="text-end">Importo da associare</th>
										<th style="width:10%;"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="f in fattureLibere" :key="f.ID_FATTURA">
										<td>n. {{ f.NUMERO }} <small class="text-muted">{{ f.DESCRIZIONE }}</small></td>
										<td class="fs-sm">{{ f.DATA_FATTURA_IT }}</td>
										<td class="text-end fs-sm">&euro; {{ filters.formattaImporto(f.IMPORTO_TOTALE) }}</td>
										<td class="text-end fs-sm">&euro; {{ filters.formattaImporto(f.RESIDUO) }} <small class="text-muted">({{ percLibera(f) }}%)</small></td>
										<td><input type="text" inputmode="decimal" class="form-control form-control-sm text-end" v-model="f.IMPORTO_PROPOSTO" @blur="f.IMPORTO_PROPOSTO = filters.formattaImporto(filters.parseImporto(f.IMPORTO_PROPOSTO))"></td>
										<td class="text-center"><button type="button" class="btn btn-success btn-sm" @click="associa(f)">Associa</button></td>
									</tr>
									<tr v-if="fattureLibere.length == 0"><td colspan="6" class="text-muted fs-sm">Nessun'altra fattura aperta per questo fornitore<span v-if="canFatturare">: creane una con "Nuova fattura per il residuo"</span>.</td></tr>
								</tbody>
							</table>
						</template>
					</template>
				</div>

				<div class="modal-footer bg-light p-2">
					<button type="button" class="btn btn-link" @click="close()"><i class="ph-x me-1"></i>Chiudi</button>
					<button type="button" class="btn btn-sm btn-primary" v-if="costo && $root.hasFunzionalita('COSTI_READ')" @click="apriCosti()"><i class="ph-arrow-square-out me-1"></i>Vai a Costi</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { utils } from '../assets/js/utils';
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'

// Il costo della voce sta nel pacchetto contabilità (SHARED_COSTI, origine VOCE): stesse API della pagina Costi
export default {
	name: 'ModalImputazioneVoce',
	components: { Datepicker },
	props: { voce: { type: Object, required: true } },
	emits: ['close', 'salvato'],
	data() {
		return { filters: global.filters, costo: null, associazioni: [], fattureAperte: [], nuova: null, caricato: false, modificato: false };
	},
	computed: {
		canCreate() { return this.$root.hasFunzionalita('COSTI_CREATE'); },
		canFatturare() { return this.canCreate && this.$root.hasFunzionalita('FATTURAZIONE_CREATE'); },
		fattureLibere() { return this.fattureAperte.filter(f => !this.associazioni.some(a => a.FK_ID_FATTURA == f.ID_FATTURA)); },
		// Il residuo è IVA compresa: si scorpora con l'aliquota scelta
		nettoNuova() {
			if (!this.nuova) return 0;
			const aliquota = this.filters.ivaSuImponibile(100, this.nuova.FK_ID_IVA) / 100;
			return Math.round(this.costo.RESIDUO / (1 + aliquota) * 100) / 100;
		}
	},
	created() {
		this.carica();
	},
	methods: {
		carica() {
			utils.ajax('theb/voce/costo', { ID_VOCE: this.voce.ID_VOCE }, (response) => {
				this.costo = response.data.COSTO;
				this.associazioni = response.data.ASSOCIAZIONI;
				this.caricato = true;
				this.fattureAperte = [];
				if (!this.costo || !(this.costo.RESIDUO > 0) || !this.canCreate) return;
				utils.ajax('shared/costi/fatture-aperte', { IDS: [this.costo.ID_COSTO] }, (resp) => {
					this.fattureAperte = resp.data.map(f => ({ ...f, IMPORTO_PROPOSTO: this.filters.formattaImporto(Math.min(f.RESIDUO, this.costo.RESIDUO)) }));
				}, true, 0, 'GET');
			}, true, 0, 'GET');
		},
		percLibera(f) {
			return f.IMPORTO_TOTALE > 0 ? Math.round(f.RESIDUO / f.IMPORTO_TOTALE * 1000) / 10 : 0;
		},
		associa(f) {
			const params = { FK_ID_COSTO: this.costo.ID_COSTO, FK_ID_FATTURA: f.ID_FATTURA, IMPORTO: this.filters.parseImporto(f.IMPORTO_PROPOSTO) };
			utils.ajax('shared/costi/associazione', params, (response) => this.dopoSalvataggio(response), true, 0, 'POST');
		},
		dissocia(a) {
			utils.alert.confirm('Togliere l\'associazione con la fattura n. ' + a.NUMERO + '?', () => {
				utils.ajax('shared/costi/associazione', { ID_ASSOCIAZIONE: a.ID_ASSOCIAZIONE }, (response) => this.dopoSalvataggio(response), true, 0, 'DELETE');
			}, this.$root);
		},
		apriNuova() {
			this.nuova = { NUMERO: '', DATA_FATTURA: new Date(), DESCRIZIONE: this.voce.TITOLO_VOCE, FK_ID_IVA: parseInt(this.costo.FK_ID_IVA) || 0 };
		},
		creaFattura() {
			const n = this.nuova;
			const params = { IDS: [this.costo.ID_COSTO], NUMERO: n.NUMERO, DATA_FATTURA: this.filters.formatDateOnly(n.DATA_FATTURA), DESCRIZIONE: n.DESCRIZIONE, NOTE: '', FK_ID_IVA: n.FK_ID_IVA, IMPORTO_NETTO: this.nettoNuova, IMPORTO_IVA: Math.round((this.costo.RESIDUO - this.nettoNuova) * 100) / 100 };
			utils.ajax('shared/costi/genera-fattura', params, (response) => {
				this.nuova = null;
				this.dopoSalvataggio(response);
			}, true, 0, 'POST');
		},
		dopoSalvataggio(response) {
			utils.alert.success(response.messaggio || 'Associazione salvata');
			this.modificato = true;
			this.carica();
		},
		apriFattura(a) {
			this.close();
			this.$router.push({ path: '/Invoice', query: { NUMERO: a.NUMERO, ANNO: a.DATA_FATTURA_IT.substr(6, 4), TIPO: 1 } });
		},
		apriCosti() {
			this.close();
			this.$router.push({ path: '/Costi', query: { ORIGINE_TIPO: 'VOCE', ORIGINE_ID: this.costo.ORIGINE_ID } });
		},
		close() {
			if (this.modificato) this.$emit('salvato');
			this.$emit('close');
		}
	}
}
</script>
